import type { TitleTestConfig } from './type';
import data from './titleTestConfig.json';

export const getTitleTestConfig = () => {
  const readData = JSON.parse(JSON.stringify(data));
  return (readData as TitleTestConfig) || [];
};
